<template lang='pug'>
  i.svg-icon.svg-icon-warn
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(fill="#3B4145" d="M61.657,16.327L92.784,70.24c1.142,1.978,1.798,4.27,1.798,6.716c0,7.432-6.023,13.456-13.456,13.456H50 L39.236,50L50,9.588C54.984,9.588,59.333,12.3,61.657,16.327z")
      path(fill="#525A61" d="M38.342,16.327L7.216,70.24c-1.142,1.978-1.798,4.27-1.798,6.716c0,7.432,6.024,13.456,13.456,13.456H50 V9.588C45.016,9.588,40.668,12.3,38.342,16.327z")
      path(fill="#F6B254" d="M88.122,72.933L56.997,19.019c-1.404-2.431-3.979-3.965-6.765-4.044l26.622,70.055h4.273 c4.451,0,8.073-3.621,8.073-8.072C89.2,75.545,88.826,74.151,88.122,72.933z")
      path(fill="#F7D167" d="M82.889,72.933c0.607,1.219,0.929,2.612,0.929,4.024c0,4.451-3.123,8.072-6.964,8.072h-57.98 c-4.451,0-8.073-3.621-8.073-8.072c0-1.412,0.373-2.806,1.076-4.024l31.127-53.914c1.442-2.498,4.123-4.049,6.997-4.049 c0.077,0,0.154,0.001,0.232,0.005c2.391,0.094,4.599,1.624,5.803,4.044L82.889,72.933z")
      path(fill="#3B4145" d="M50,67.089v8.971c2.479,0,4.485-2.009,4.485-4.484C54.485,69.098,52.479,67.089,50,67.089z")
      path(fill="#525A61" d="M50,67.089c0.495,0,0.897,2.009,0.897,4.486c0,2.476-0.402,4.484-0.897,4.484 c-2.478,0-4.485-2.009-4.485-4.484C45.515,69.098,47.522,67.089,50,67.089z")
      path(fill="#3B4145" d="M50,28.518v33.19c2.479,0,4.485-2.009,4.485-4.484V33.003C54.485,30.526,52.479,28.518,50,28.518z")
      path(fill="#525A61" d="M50,28.518c0.495,0,0.897,2.008,0.897,4.485v24.221c0,2.476-0.402,4.484-0.897,4.484 c-2.478,0-4.485-2.009-4.485-4.484V33.003C45.515,30.526,47.522,28.518,50,28.518z")

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>